"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ isBundle, numberCircleColor, dimmed }) => {
    const theme = (0, material_1.useTheme)();
    const container = Object.assign(Object.assign({ width: '100%', minHeight: '1.5rem', paddingBottom: isBundle ? '1rem' : '', paddingLeft: isBundle ? '1rem' : '', boxShadow: 'none' }, theme.qlub.typography.body_sm), { display: 'flex', flexDirection: 'column', gap: '0.5rem' });
    const foodItemCard = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: 'none',
    };
    const foodCard = {
        display: 'flex',
        alignItems: 'center',
        padding: '0px !important',
        gap: '8px',
        '& .foodName': {
            color: dimmed
                ? theme.qlub.palette.onSurfaceColors.mediumEmphasis
                : theme.qlub.palette.onSurfaceColors.highEmphasis,
        },
        '& .quantity': {
            color: theme.qlub.palette.iris_light.hover,
        },
        '& .number': Object.assign(Object.assign({}, theme.qlub.typography.caption_overline), { color: theme.qlub.palette.onSurfaceColors.highEmphasis, backgroundColor: numberCircleColor || theme.qlub.palette.iris_light.hover, borderRadius: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '24px', height: '24px', padding: '4px' }),
        '& .icon': {
            backgroundColor: theme.qlub.palette.dim.main,
            borderRadius: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '24px',
            height: '24px',
        },
    };
    const selectorStyle = Object.assign({ display: 'flex', padding: 0, alignItems: 'center', gap: '0.5rem' }, theme.qlub.typography.body_sm);
    const priceStyle = {
        color: theme.qlub.palette.onSurfaceColors.highEmphasis,
    };
    const discountStyle = {
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        textDecorationLine: 'line-through',
    };
    const attributeStyle = {
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
        display: 'flex',
        justifyContent: 'space-between',
        gap: '0.5rem',
        alignItems: 'center',
    };
    const discountRowStyle = {
        color: theme.qlub.palette.success.main,
        display: 'flex',
        justifyContent: 'space-between',
        gap: '0.5rem',
        alignItems: 'center',
    };
    const attributeSpan = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    };
    const taxDiscountSpan = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.8rem',
    };
    return {
        container,
        foodItemCard,
        foodCard,
        selectorStyle,
        priceStyle,
        discountStyle,
        attributeStyle,
        attributeSpan,
        discountRowStyle,
        taxDiscountSpan,
    };
};
exports.default = useStyle;
